import { GantStand } from '../interfaces/gant-stand';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Stand } from '../interfaces/stand';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../services/authentication.service';
@Injectable({
  providedIn: 'root'
})
export class StandsApiService {
  gant(entity_structure_id: number, start: Date, end: Date): Observable<GantStand[]>  {
    return this.httpClient.post<GantStand[]>(environment.servers[environment.srv_mode].host + `/gant`, {
      "ID" : entity_structure_id,
      "StartDate": start,
      "EndDate": end,
      "user": this.authServ.getUser()
    });
  }

  constructor(private httpClient: HttpClient,private authServ: AuthenticationService) { }


  getStands(id:number|undefined): Observable<Stand[]>{
    return this.httpClient.post<Stand[]>(environment.servers[environment.srv_mode].host + `/stands/${id}`,{user:this.authServ.getUser()});
  }

}
